import { createExporter } from "utils/createExporter";
import { TransactionStatusChoices } from "utils/choices";
import { CASH_PAYMENTS, ONLINE_PAYMENTS, PAYMENT_EXPECTATIONS, BANK_TRANSFERS } from "utils/constants";
import { paymentRequests } from "api/paymentApi";

const COMMON_USER_INFO_COLUMNS = [
  { key: "firstName", label: "име" },
  { key: "secondName", label: "презиме" },
  { key: "lastName", label: "фамилия" },
];

const COMMON_COLUMNS = [
  { key: "id", label: "номер" },
  ...COMMON_USER_INFO_COLUMNS,
  { key: "amount", label: "сума" },
  { key: "description", label: "описание" },
];

const COMMON_PAYMENT_COLUMNS = [
  { key: "createTimestamp", label: "дата на създаване" },
  { key: "paymentTimestamp", label: "дата на плащане" },
  { key: "eshop", label: "Е-магазин" },
  { key: "status", label: "статус" },
];

const BANK_TRANSFERS_COLUMNS = [
  ...COMMON_COLUMNS,
  { key: "reason", label: "основание за плащане" },
  ...COMMON_PAYMENT_COLUMNS,
];

const ONLINE_PAYMENTS_COLUMNS = [
  ...COMMON_COLUMNS,
  { key: "paymentProvider", label: "канал" },
  { key: "externalId", label: "външен номер" },
  ...COMMON_PAYMENT_COLUMNS,
];

const CASH_PAYMENTS_COLUMNS = [
  ...COMMON_COLUMNS,
  { key: "paymentTimestamp", label: "дата на плащане" },
  { key: "eshop", label: "Е-магазин" },
];

const PAYMENT_EXPECTATIONS_COLUMNS = [
  { key: "Id", label: "ИД кандидатура" },
  ...COMMON_COLUMNS,
  { key: "admissionNumber", label: "входящ номер" },
  { key: "currency", label: "валута" },
  { key: "createdOn", label: "дата" },
];

const status = recordStatus => TransactionStatusChoices.find(choice => choice.id === recordStatus);

export const CashflowExporter = type => {
  const columnsMap = {
    [BANK_TRANSFERS]: BANK_TRANSFERS_COLUMNS,
    [ONLINE_PAYMENTS]: ONLINE_PAYMENTS_COLUMNS,
    [CASH_PAYMENTS]: CASH_PAYMENTS_COLUMNS,
    [PAYMENT_EXPECTATIONS]: PAYMENT_EXPECTATIONS_COLUMNS,
  };

  const mapCommonUserInfo = record => ({
    firstName: record.userInfo?.firstName,
    secondName: record.userInfo?.secondName,
    lastName: record.userInfo?.lastName,
  });

  const mapperMap = {
    [BANK_TRANSFERS]: record => ({
      ...record,
      ...mapCommonUserInfo(record),
      eshop: record.eshop?.name,
      status: status(record.status)?.name,
    }),

    [ONLINE_PAYMENTS]: record => ({
      ...record,
      ...mapCommonUserInfo(record),
      paymentProvider: record.paymentProvider?.nameBg,
      eshop: record.eshop?.name,
      status: status(record.status)?.name,
    }),

    [CASH_PAYMENTS]: record => ({
      ...record,
      ...mapCommonUserInfo(record),
      eshop: record.eshop?.name,
    }),

    [PAYMENT_EXPECTATIONS]: record => ({
      ...record,
    }),
  };

  const columns = columnsMap[type];

  const mapper = mapperMap[type] || (r => r);

  const relations =
    type === PAYMENT_EXPECTATIONS
      ? []
      : [
          {
            source: "eshopId",
            target: paymentRequests.getEshopsSelect(),
            name: "eshop",
          },
        ];

  const fileName = type.replace(/[-/]/g, "_");

  return createExporter(`payment_${fileName}.xlsx`, columns, mapper, relations);
};
